import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { Actions, Types } from '../reducers/Categories';
import { getCategories, getFormations } from 'services/requests/categories';
import { Alert } from 'helpers/Alert';

function* getCategoriesData() {
  try {
    const response = yield call(getCategories);
    yield put(Actions.setCategories(response.data));
  } catch (error) {
    console.error('[getCategories] failed', {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    yield put(Actions.getCategoriesFailed(error.message));
    Alert({
      type: 'error',
      title: 'Error',
      text: 'Could not load categories. Please try again.',
    });
  }
}

export function* WatchGetCategories() {
  yield takeEvery(Types.GET_CATEGORIES, getCategoriesData);
}

function* getFormationsData() {
  try {
    const response = yield call(getFormations);
    yield put(Actions.setFormations(response.data));
  } catch (error) {
    console.error('[getFormations] failed', {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    yield put(Actions.getFormationsFailed(error.message));
    Alert({
      type: 'error',
      title: 'Error',
      text: 'Could not load formations. Please try again.',
    });
  }
}

export function* WatchGetFormations() {
  yield takeEvery(Types.GET_FORMATIONS, getFormationsData);
}

export default function* actsSaga() {
  yield all([fork(WatchGetCategories), fork(WatchGetFormations)]);
}
